import * as React from "react";
const SvgFiRrLinkSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-link-slash_svg__a)">
      <path
        fill="#062147"
        d="M4.262 9.772a1 1 0 1 1 1.412 1.417l-2.197 2.19A5 5 0 0 0 2 16.941c0 1.346.524 2.612 1.477 3.564A5.05 5.05 0 0 0 7.047 22a5.03 5.03 0 0 0 3.557-1.458l2.208-2.215a1 1 0 1 1 1.416 1.413l-2.209 2.216A7.03 7.03 0 0 1 7.036 24a7.05 7.05 0 0 1-4.973-2.079A7 7 0 0 1 0 16.943c0-1.88.732-3.649 2.063-4.98zm4.267 4.284-.8.801a.999.999 0 1 0 1.413 1.414l.801-.8a.999.999 0 1 0-1.414-1.415M.293.293a1 1 0 0 1 1.414 0l6.02 6.02.002-.006 4.252-4.245A7 7 0 0 1 16.961 0c1.88 0 3.647.732 4.977 2.062A7 7 0 0 1 24 7.042a7 7 0 0 1-2.062 4.977l-4.245 4.253-.005.003 6.02 6.02a.999.999 0 1 1-1.415 1.413l-22-22a1 1 0 0 1 0-1.415M12 10.585l2.86-2.859a.999.999 0 1 1 1.413 1.414L13.413 12l2.862 2.861.002-.003 4.246-4.253A5 5 0 0 0 22 7.041a5 5 0 0 0-1.477-3.564 5 5 0 0 0-3.563-1.476 5 5 0 0 0-3.565 1.477L9.142 7.724l-.003.002 2.86 2.86"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-link-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLinkSlash;
